import { render } from "./AdSets.vue?vue&type=template&id=60f18398"
import script from "./AdSets.vue?vue&type=script&lang=js"
export * from "./AdSets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__